export const getFromTo = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let from = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    let to = fromDate.getFullYear() + '-' + ((+fromDate.getMonth()) + 1) + '-' + (fromDate.getDate());
    // console.log(from, to)
    return [from, to];
}

export const getGraphDateTime = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let Gfrom = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    let Gto = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    // console.log(from, to)
    return [Gfrom, Gto];
}

export function getDateTimeForTab3() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 7);

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}

export function getDateTimeForDashboardTab1() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 10);

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}

export function getDateTimeForPvParameter() {
    // Get the current date
    var currentDate = new Date();

    // Get the date from 10 days ago
    var tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate() - 2);

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}


export function getDateTimeForTab2() {
    // Get the current date
    let currentDate = new Date();

    // Get the date from 10 days ago
    let tenDaysAgo = new Date();
    tenDaysAgo.setDate(currentDate.getDate());

    // Format the dates if needed
    var formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo
    }
}

export const getGraphTab3DateTime = () => {
    let currentDate = new Date();
    let fromDate = new Date();
    fromDate.setDate(currentDate.getDate() - 10);
    let Gfrom = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate() - 7);
    let Gto = currentDate.getFullYear() + '-' + ((+currentDate.getMonth()) + 1) + '-' + (currentDate.getDate());
    // console.log(from, to)
    return [Gfrom, Gto];
}



export function getFormattedDateTime(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function getFormattedStaticDateTime(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = '05'
    const minutes = '00';

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}


export function getFormattedDateTimeForHYBRD(daysOffset = 0) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
